export default "__VITE_ASSET__80cf9336__"